<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout v-resize="onResize" column style="margin-top: 10px;">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="data"
      :pagination.sync="pagination"
      :hide-headers="isMobile"
      :class="{ mobile: isMobile }"
      :item-key="itemKey"
      :total-items="totalItems"
      rows-per-page-text="每页行数"
      no-results-text="没有找到结果"
      select-all
    >
      <template v-slot:items="props">
        <tr
          v-if="!isMobile"
          :key="props.index"
          :active="props.selected"
          @click="detailButtonClicked(props.item)"
        >
          <td>
            <v-checkbox
              v-if="!(props.item['status'] && props.item['status']!=='已禁用')"
              v-model="props.selected"
              :disabled="props.item['status'] && props.item['status']!=='已禁用'"
              primary
              hide-details
              @click.stop="props.selected = !props.selected"
            ></v-checkbox>
          </td>
          <td v-for="header in headers" :key="header.value" :class="header.customClass">
            <template v-if="header.value==='settings'">
              <div style="display: flex;justify-content: center">
                <v-btn
                  style="margin:0 5px !important;"
                  color="info"
                  outline
                  small
                  @click="detailButtonClicked(props.item)"
                >
                  详情
                </v-btn>
                <v-btn
                  v-if="header.showDownload"
                  style="margin:0 5px !important;"
                  color="success"
                  small
                  @click="downloadButtonClicked($event,props.item)"
                >
                  下载
                </v-btn>
                <v-btn
                  v-if="!header.hideEdit"
                  style="margin:0 5px !important;"
                  color="info"
                  small
                  @click="editButtonClicked($event,props.item)"
                >
                  编辑
                </v-btn>
                <!--客户状态-->
                <template v-if="props.item['status']==='已禁用' || props.item['status']==='潜在客户'">
                  <v-btn
                    style="margin:0 5px !important;"
                    color="success"
                    small
                    @click="statusButtonClicked($event,props.item)"
                  >
                    开通
                  </v-btn>
                </template>
                <template v-else-if="props.item['status']==='已开通'">
                  <v-btn
                    style="margin:0 5px !important;"
                    color="warning"
                    small
                    @click="statusButtonClicked($event,props.item)"
                  >
                    禁用
                  </v-btn>
                </template>
                <!--客户状态-->

                <!--用户状态-->
                <template v-if="props.item['isTerminated']===true">
                  <v-btn
                    style="margin:0 5px !important;"
                    color="success"
                    small
                    @click="statusButtonClicked($event,props.item)"
                  >
                    开通
                  </v-btn>
                </template>
                <template v-else-if="props.item['isTerminated']===false">
                  <v-btn
                    style="margin:0 5px !important;"
                    color="warning"
                    small
                    @click="statusButtonClicked($event,props.item)"
                  >
                    禁用
                  </v-btn>
                </template>
                <!--用户状态-->
              </div>
            </template>
            <template v-else-if="header.value==='settings-comp'">
              <div style="display: flex;justify-content: center">
                <v-btn
                  style="margin:0 5px !important;"
                  color="info"
                  outline
                  small
                  @click="showContractButtonClicked(props.item)"
                >
                  查看合同
                </v-btn>
              </div>
            </template>
            <template v-else>
              <template v-if="header.value==='progress'">
                <template v-if="props.item[header.value]==='已创建'">
                  <span style="color:#FF4848">已创建</span>
                </template>
                <template v-else-if="props.item[header.value]==='正在处理'">
                  <span style="color:#2085F5">正在处理</span>
                </template>
                <template v-else-if="props.item[header.value]==='已完成'">
                  <span style="color:#00C000">已完成</span>
                </template>
                <template v-else>
                  {{ props.item[header.value] }}
                </template>
              </template>
              <template v-else>
                {{
                  header.formatter
                    ? header.formatter(props.item[header.value])
                    : props.item[header.value]
                }}
              </template>
            </template>
          </td>
        </tr>
        <!--手机端-->
        <tr
          v-else
          :key="props.index"
          :active="props.selected"
          @click="mobileTrClicked(props)"
        >
          <td>
            <v-container fluid grid-list-md class="xn-form pa-0">
              <v-layout wrap>
                <v-flex v-for="header in headers.filter(h => h.value!=='settings' && h.value!=='settings-comp')" :key="header.value" xs6>
                  <p class="datatable-title">{{ header.text }}</p>
                  <p :class="header.customClass">
                    {{
                      header.formatter
                        ? header.formatter(props.item[header.value])
                        : props.item[header.value]
                    }}
                  </p>
                </v-flex>
                <v-flex v-for="header in headers.filter(h => h.value!=='settings' && h.value==='settings-comp')" :key="header.value" xs6>
                  <p class="datatable-title">{{ header.text }}</p>
                  <div style="display: flex;">
                    <v-btn
                      style="margin:0 5px !important;"
                      color="info"
                      outline
                      small
                      @click="showContractButtonClicked(props.item)"
                    >
                      查看合同
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex v-for="header in headers.filter(h => h.value==='settings')" :key="header.value" xs12>
                  <p class="datatable-title">{{ header.text }}</p>
                  <div style="display: flex;">
                    <v-btn
                      style="margin:0 5px !important;"
                      color="info"
                      outline
                      small
                      @click="detailButtonClicked(props.item)"
                    >
                      详情
                    </v-btn>
                    <v-btn
                      v-if="header.showDownload"
                      style="margin:0 5px !important;"
                      color="success"
                      small
                      @click="downloadButtonClicked($event,props.item)"
                    >
                      下载
                    </v-btn>
                    <v-btn
                      v-if="!header.hideEdit"
                      style="margin:0 5px !important;"
                      color="info"
                      small
                      @click="editButtonClicked($event,props.item)"
                    >
                      编辑
                    </v-btn>
                    <template v-if="props.item['status']==='已禁用' || props.item['status']==='潜在客户'">
                      <v-btn
                        style="margin:0 5px !important;"
                        color="success"
                        small
                        @click="statusButtonClicked($event,props.item)"
                      >
                        开通
                      </v-btn>
                    </template>
                    <template v-else-if="props.item['status']==='已开通'">
                      <v-btn
                        style="margin:0 5px !important;"
                        color="warning"
                        small
                        @click="statusButtonClicked($event,props.item)"
                      >
                        禁用
                      </v-btn>
                    </template>
                    <!--用户状态-->
                    <template v-if="props.item['isTerminated']===true">
                      <v-btn
                        style="margin:0 5px !important;"
                        color="success"
                        small
                        @click="statusButtonClicked($event,props.item)"
                      >
                        开通
                      </v-btn>
                    </template>
                    <template v-else-if="props.item['isTerminated']===false">
                      <v-btn
                        style="margin:0 5px !important;"
                        color="warning"
                        small
                        @click="statusButtonClicked($event,props.item)"
                      >
                        禁用
                      </v-btn>
                    </template>
                    <!--用户状态-->
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </td>
        </tr>
        <!--手机端-->
      </template>
      <template v-slot:no-data>
        <div v-if="!isLoading">
          {{ noDataText }}
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </template>

      <!--注意，只有开票信息管理，才可以看到-->
      <template v-if="showFooter" v-slot:footer>
        <td v-if="!isMobile" class="bold" style="border-top:1px solid #e0e0e0">统计:</td>
        <td v-if="!isMobile"></td>
        <td v-if="!isMobile"></td>
        <td v-if="!isMobile"></td>
        <td v-if="!isMobile"></td>
        <td v-if="!isMobile" class="bold money">{{ totalPrice }}</td>
        <td v-if="!isMobile" class="bold money">{{ totalTax }}</td>
        <td v-if="!isMobile" class="bold text-xs-right">价税合计:</td>
        <td v-if="!isMobile" class="bold money">{{ totalSum }}</td>

        <td v-if="isMobile">总金额合计:&nbsp; <span class="money">{{ totalPrice }}</span></td>
        <td v-if="isMobile">总税额合计:&nbsp; <span class="money">{{ totalTax }}</span></td>
        <td v-if="isMobile">价税合计:&nbsp; <span class="money">{{ totalSum }}</span></td>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
  import {EventBus} from "../event";

  export default {
    name: "DataTable2",
    props: {
      headers: {
        type: Array,
        required: true
      },
      fetchData: {
        type: Function,
        required: true
      },
      itemKey: {
        type: String,
        required: true
      },
      sortBy: {
        type: String,
        required: true
      },
      showFooter: {
        type: Boolean,
        default: false
      },
      totalPrice: {
        type: Number,
        default: 0
      },
      totalTax: {
        type: Number,
        default: 0
      }
    },
    computed: {
      totalSum() {
        let sum = this.totalPrice + this.totalTax;
        return sum.toFixed(2);
      }
    },
    methods: {
      changeSort(column) {
        if (this.pagination.sortBy === column && !this.pagination.descending) {
          this.pagination.descending = true;
        } else if (
          this.pagination.sortBy === column &&
          this.pagination.descending
        ) {
          this.pagination.sortBy = null;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      },
      mobileTrClicked(props) {
        if (props.item['status'] && props.item['status'] !== '已禁用') {
          return;
        }
        props.selected = !props.selected
      },
      onResize() {
        this.isMobile = window.innerWidth < 769;
      },
      editButtonClicked(event,item) {
        event.stopPropagation();
        this.$emit("editButtonClicked", item);
      },
      detailButtonClicked(item) {
        this.$emit("detailButtonClicked", item);
      },
      showContractButtonClicked(item) {
        this.$emit("showContractButtonClicked", item);
      },
      statusButtonClicked(event,item) {
        event.stopPropagation();
        this.$emit("statusButtonClicked", item);
      },
      downloadButtonClicked(event,item) {
        event.stopPropagation();
        this.$emit("downloadButtonClicked", item);
      },
      // deleteButtonClicked(item) {
      //   let arr = [];
      //   arr.push(item);
      //   this.$emit("deleteButtonClicked", arr);
      // },
      refresh() {
        this.isLoading = true;
        this.fetchData(
          this.pagination,
          this.searchText,
          (totalItems, data) => {
            this.noDataText = "没有找到结果";
            this.isLoading = false;
            this.data = data;
            this.totalItems = totalItems;
          },
          error => {
            if (!error.response) {
              this.noDataText = "网络连接失败";
            } else {
              if (error.response.status / 100 === 4) {
                this.noDataText = "无效请求";
              } else if (error.response.status / 100 === 5) {
                this.noDataText = "服务器错误";
              } else {
                this.noDataText = "未知错误";
              }
            }
            this.data = [];
            this.isLoading = false;
          }
        );
      },
    },
    data: () => ({
      noDataText: "",
      data: [],
      selected: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: null
      },
      isMobile: false,
      totalItems: 0,
      isLoading: true,
    }),
    watch: {
      pagination: {
        handler() {
          this.refresh();
        },
        deep: true
      },
    },
    created() {
      EventBus.$on("refresh", () => {
        this.refresh();
      });
      this.pagination.sortBy = this.sortBy;
    }
  }
</script>

<style scoped>
  .mobile {
    color: #333;
  }

  .mobile tr[active='true'] {
    background: rgba(0, 0, 0, 0.1) !important;
  }

  @media screen and (max-width: 768px) {
    .mobile table.v-table tr {
      max-width: 100%;
      position: relative;
      display: block;
    }

    .mobile table.v-table tr:nth-child(odd) {
      border-left: 6px solid deeppink;
    }

    .mobile table.v-table tr:nth-child(even) {
      border-left: 6px solid cyan;
    }

    .mobile table.v-table tr td {
      display: flex;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      height: auto;
      padding: 10px;
    }

    .mobile table.v-table tr td ul li:before {
      content: attr(data-label);
      padding-right: 0.5em;
      text-align: left;
      display: block;
      color: #999;
    }

    .v-datatable__actions__select {
      width: 50%;
      margin: 0px;
      justify-content: flex-start;
    }

    .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
      background: transparent;
    }
  }

  .flex-content {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 50%;
    height: 40px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .datatable-title {
    font-weight: bold;
    color: #aaaaaa;
    margin-bottom: 5px;
  }
</style>
